/* Page to display the info for the Scene Page Shotlist 
   and Storyboard features */
import React from "react";
import { useHistory } from "react-router-dom";
import styles from "../../styles/Home.module.css";
import appStyles from "../../App.module.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import break2 from "../../assets/break2.png";
import story1 from "../../assets/story1.png";
import shotstory1 from "../../assets/shotstory1.png";
import shotmo1 from "../../assets/shotmo1.png";
import shotinfomo1 from "../../assets/shotinfomo1.png";
import shotim from "../../assets/shotim.png";
import shot5 from "../../assets/shot5.png";
import shot7 from "../../assets/shot7.png";
import moeditshot from "../../assets/moeditshot.png";
import scenescript from "../../assets/scenescript.png";
import btnStyles from "../../styles/Button.module.css";
import Button from "react-bootstrap/Button";
import { Image } from "react-bootstrap";

const ShotStory = () => {
  const history = useHistory();
  
  return (
    <div className={`mt-0 ${styles.BlueBody}`}>
      <h2 className={`text-center py-2 ${styles.SubTitle } ${appStyles.cinzel}`}>
            SCENES WORKSPACE - STORYBOARD & SHOTLIST & SCRIPT</h2>
    <Row className="mt-1" >
        <Col xs={3}>
        <Button
          className={`${btnStyles.Button} ${btnStyles.Blue} mb-2`}
          onClick={() => history.goBack()}
        >
          Back
        </Button>
        </Col>
    </Row>
    {/* desktop */}
    <div className="d-none d-md-block">
    {/* story 1 */}
    <Row className="mt-1 mt-md-3 px-3 pb-4 d-flex align-items-center justify-content-center">
    <Col xs={12} md={{span: 3, offset: 1 }} className="text-center" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Create the Scene Storyboard in your prefered method then upload it 
    to the Scene Page
    </h4>
    <h4 >
    Storyboard Pri-vis videos may also be uploaded and viewed on the page
    </h4>
    </div>
    </Col>
    <Col xs={12} md={8}>
    <div className="text-center">
    <Image src={story1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* shot 2 */}
    <Row className="px-3 pb-4 mt-4 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center">
    <Image src={shot7} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
      className="text-center" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Create easy to read Shotlists for each Scene the main Info displaying on top
    </h4>
    <h4 >
    Use Drag and Drop to re-order Shots quickly and automatically change
    all Shot Numbers
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* shot 3 */}
    <Row className="px-3 pb-4 mt-4 d-flex align-items-center justify-content-center">
    <Col xs={12} md={{span: 3, offset: 1 }}
      className="text-center" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Click the Info tab to view the extra Info added
    </h4>
    </div>
    </Col>
    <Col xs={12} md={8}>
    <div className="text-center">
    <Image src={shot5} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* shot 4 */}
    <Row className="px-3 pb-4 mt-4 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center">
    <Image src={shotim} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
      className="text-center" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Click the Image link to view the Shot Sketch if added
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* story/shotlist 5 */}
    <Row className="px-3 pb-4 mt-4 d-flex align-items-center justify-content-center">
    <Col xs={12} md={{span: 3, offset: 1 }}
      className="text-center" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    View the Storyboard and the Shotlist
    side by side to facilitate Shotlist creation
    </h4>
    </div>
    </Col>
    <Col xs={12} md={8}>
    <div className="text-center">
    <Image src={shotstory1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* scipt 6 */} 
    <Row className="px-3 mt-4 pb-4 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
    <Image src={scenescript} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
      className="text-center px-1 px-md-3" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    The Scene Script can be added to the Scene page if desired and changed when necessary
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* full script */}
    <Row className="px-3 pb-4 mt-4 d-flex align-items-center justify-content-center">
    <Col xs={12} md={{span: 3, offset: 1 }}
      className="text-center" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Add the Full Script to the Scenes page along with
    changes details and notes
    </h4>
    </div>
    </Col>
    <Col xs={12} md={8}>
    <div className="text-center">
    <Image src={break2} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    <div>
    {/* shotlist mo */}
    <Row className="px-3 pb-md-4 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={6}>
    <div className="text-center px-1 px-md-3">
    <Image src={shotmo1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    <div className={` ${styles.FeatureBox1} text-center mx-3 mt-3`}>
    <h4 >
    The Shotlist in Mobile View
    </h4>
    </div>
    {/* mo hr */}
    </Col>
    <Col xs={12} md={6}>
    <div className="text-center px-1 px-md-3">
    <Image src={shotinfomo1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    <div className={` ${styles.FeatureBox1} text-center mx-3 mt-3`}>
    <h4 >
    A Shot's Extra Info in Mobile View
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 5 shotlist */}
    <Row className="px-3 pb-md-4 mt-3">
    <Col xs={12} md={{span: 6, offset: 3}}>
    <div className="text-center px-1 px-md-3">
    <Image src={moeditshot} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    <div className={` ${styles.FeatureBox1} text-center mx-3 mt-3`}>
    <h4 >
    The Shotlist Edit page in Mobile View
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    </div>
    </div>
    {/* mobile */}
    <div className="d-block d-md-none">
    {/* story 1 */}
    <Row className="mt-3 px-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1 px-md-3">
    <Image src={story1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 1 }} className="text-center mt-5 px-3" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Create the Scene Storyboard in your prefered method then upload it 
    to the Scene Page
    </h4>
    <h4 >
    Storyboard Pri-vis videos may also be uploaded and viewed on the page
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* shot 2*/}
    <Row className="px-3 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1">
    <Image src={shot7} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
      className="text-center mt-5 px-3" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Create easy to read Shotlists for each Scene the main Info displaying on top
    </h4>
    <h4 >
    Use Drag and Drop to re-order Shots quickly and automatically change
    all Shot Numbers
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* shot 3 */}
    <Row className="px-3 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1">
    <Image src={shot5} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} className="text-center mt-5 px-3" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Click the Info tab to view the extra Info added
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* shot 4 */}
    <Row className="px-3 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1">
    <Image src={shotim} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }} className="text-center px-3 mt-5" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Click the Image link to view the Shot Sketch if added
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* story/shotlist  */}
    <Row className="px-3 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1">
    <Image src={shotstory1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} className="text-center px-3 mt-5" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    View the Storyboard and the Shotlist
    side by side to facilitate Shotlist creation
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* scene scipt */} 
    <Row className="px-3 mt-4 pb-4 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1">
    <Image src={scenescript} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} md={{span: 3, offset: 0 }}
      className="text-center px-1 mt-5" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    The Scene Script can be added to the Scene page if desired and changed when necessary
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* full script  */}
    <Row className="px-3 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={8}>
    <div className="text-center px-1">
    <Image src={break2} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    </Col>
    <Col xs={12} className="text-center px-3 mt-5" >
    <div className={` ${styles.FeatureBox1}`}>
    <h4 >
    Add the Full Script to the Scenes page along with
    changes details and notes
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    <div>
    {/* shotlist mo */}
    <Row className="px-3 pb-md-4 mt-3 d-flex align-items-center justify-content-center">
    <Col xs={12} md={6}>
    <div className="text-center px-1 px-md-3">
    <Image src={shotmo1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    <div className={` ${styles.FeatureBox1} text-center mx-3 mt-5`}>
    <h4 >
    The Shotlist in Mobile View
    </h4>
    </div>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    </Col>
    <Col xs={12} md={6}>
    <div className="text-center px-1 px-md-3">
    <Image src={shotinfomo1} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    <div className={` ${styles.FeatureBox1} text-center mx-3 mt-5`}>
    <h4 >
    A Shot's Extra Info in Mobile View
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    {/* 5 shotlist */}
    <Row className="px-3 pb-md-4 mt-3">
    <Col xs={12} md={{span: 6, offset: 3}}>
    <div className="text-center px-1 px-md-3">
    <Image src={moeditshot} alt="image" 
      className={` ${styles.FeatureImage}`} />
    </div>
    <div className={` ${styles.FeatureBox1} text-center mx-3 mt-5`}>
    <h4 >
    The Shotlist Edit page in Mobile View
    </h4>
    </div>
    </Col>
    </Row>
    <div className={`${styles.Overview} py-2 mt-3 px-0 mx-0`}>
    <hr className={`${styles.Five} py-2 mt-3 px-0 mx-0`}>
    </hr>
    </div>
    </div>
    </div>
    </div>
  )
}

export default ShotStory